export const SET_YEARMONTHS = "SET_YEARMONTHS";

export interface YearmonthsState {
  yearmonths: string[];
  error: boolean;
}
